import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";

type MyHrLoginTwoFactorTotpInfoProps = {
  onCancel: () => void;
  onForward: (step: string) => void;
  isMobile: boolean;
};

export const MyHrLoginTwoFactorTotpInfo = ({
  onCancel,
  onForward,
  isMobile,
}: MyHrLoginTwoFactorTotpInfoProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: isMobile ? "auto" : "304px",
        padding: isMobile ? "0px 24px" : "unset",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_2FA_AUTHENTICATION")}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_PROTECT_ACCOUNT_TWO_STEPS")}
      </Typography>
      <Box sx={{ textAlign: "left", marginTop: "24px", marginBottom: "16px" }}>
        <Typography variant="body1">
          {t("MY_HR_LINK_AUTHENTICATOR_APP")}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        sx={{
          textAlign: "left",
          marginTop: "24px",
          marginBottom: "16px",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            backgroundColor: "#C6CACC",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
            fontWeight: 700,
            flexShrink: 0,
            borderRadius: "2px",
          }}
        >
          1
        </Box>
        <Typography variant="body1">
          {t("MY_HR_USE_COMPATIBLE_AUTHENTICATOR_APP")}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        sx={{
          textAlign: "left",
          marginTop: "24px",
          marginBottom: "16px",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            backgroundColor: "#C6CACC",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
            fontWeight: 700,
            flexShrink: 0,
            borderRadius: "2px",
          }}
        >
          2
        </Box>
        <Typography variant="body1">
          {t("MY_HR_ENTER_VERIFICATION_CODE")}
        </Typography>
      </Box>
      <Button
        id="next"
        variant="contained"
        color="primary"
        sx={{ marginTop: "16px" }}
        onClick={() => onForward("two-factor-totp-register")}
        fullWidth
      >
        {t("OC_NEXT")}
      </Button>
      <Button
        id="cancel"
        variant="text"
        color="secondary"
        fullWidth
        sx={{ marginTop: "32px" }}
        onClick={onCancel}
      >
        {t("OC_CANCEL")}
      </Button>
    </Box>
  );
};

export default MyHrLoginTwoFactorTotpInfo;
